import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as Constants from '@emi/shared/constants';

@Component({
    selector: 'via-button-bar',
    templateUrl: './button-bar.component.html',
    styleUrls: ['./button-bar.component.scss'],
})
export class ButtonBarComponent {
    @Input()
    public buttonDisabled = false;

    @Input()
    public showCancelModal = false;

    @Input()
    public route = '/';

    @Input()
    public iconClass = 'fas fa-times';

    @Input()
    public buttonLabel = 'Cancel';

    @Input()
    public modalType = '';

    constructor(private router: Router) {}

    public buttonClicked(): void {
        this.router.navigate([Constants.Routes.EXPORT_ROUTE]);
    }
}
